import { Form as Unform } from '@unform/web';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vh - 4rem); 
`;

export const Form = styled(Unform)`
  display: flex;
  flex-direction: column;
  width: 380px;
  max-width: 80%;

  @media (max-width: 750px) {
    img {
      width: 320px !important;
    }
  }

  a {
    margin: 2rem 0;
    text-align: end;
    color: var(--gray-800);
  }

  img {
    width: 400px;
    margin-left: -20px;
    margin-bottom: 4rem;
  }

  #login-button {
    background-color: var(--light-blue);
    color: white;
    height: 3rem;
    border: var(--light-blue);
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
  }
`;

